<script>
// Pro tuto funkci je potřeba nainstalovat knihovnu xlsx:
// npm install xlsx
// nebo
// yarn add xlsx
import * as XLSX from 'xlsx';
import axios  from "axios";

export default {
  name: "my_students",
  data() {
    return {
      students: [],
      headers: []
    };
  },
  methods: {
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const json = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

        if (json.length > 0) {
          const originalHeaders = json[0];
          this.headers = originalHeaders.map(h => (h || '').toString().trim().replace(/\s+/g, '_').toLowerCase());

          this.students = json.slice(1).map(row => {
            let student = {};
            this.headers.forEach((header, index) => {
              student[header] = row[index];
            });
            return student;
          });
        }
      };
      reader.readAsArrayBuffer(file);
    },
    async sendData() {
      if (this.students.length === 0) {
        alert("Nejsou žádná data k odeslání.");
        return;
      }

      try {
        const csrfToken = document.querySelector("meta[name='csrf-token']").getAttribute('content');
        const response = await axios.post('/ll/students/import',
            { students: this.students },
            { headers: { 'X-CSRF-Token': csrfToken } }
        );

        alert('Studenti byli úspěšně importováni!');
        this.students = [];
        this.headers = [];
        this.$refs.fileInput.value = '';
      } catch (error) {
        console.error('Došlo k chybě:', error);
        if (error.response) {
          const errorData = error.response.data;
          alert(`Chyba při importu: ${errorData.message || error.message}`);
        } else {
          alert('Došlo k chybě při odesílání dat.');
        }
      }
    }
  }
}
</script>

<template>
  <div>
    <h3>Importovat studenty z XLSX</h3>
    <div class="mb-3">
      <label for="fileInput" class="form-label">Vyberte XLSX soubor</label>
      <input class="form-control" type="file" id="fileInput" @change="handleFileUpload" accept=".xlsx, .xls" ref="fileInput">
    </div>

    <div v-if="students.length > 0">
      <h4>Náhled dat</h4>
      <p>Zkontrolujte prosím data před importem. Bude importováno {{ students.length }} studentů.</p>
      <div class="table-responsive">
        <table class="table table-striped table-bordered">
          <thead>
          <tr>
            <th v-for="header in headers" :key="header">{{ header }}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(student, index) in students" :key="index">
            <td v-for="header in headers" :key="header">{{ student[header] }}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <button @click="sendData" class="btn btn-success">Odeslat data na server</button>


      <pre>{{students}}</pre>
    </div>
  </div>
</template>

<style scoped>
/* Styly můžete přidat zde */
</style>